import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import { useAuthStore } from './stores/authStore'
import { UrgentBroadcastController } from './components/Modals/UrgentBroadcastModal'
import { InfoBannerController } from './components/Banners/InfoBanner'

// Lazy load pages for code splitting
const LoginPage = lazy(() => import('./pages/LoginPage'))
const PanelPage = lazy(() => import('./pages/PanelPage'))
const AdminPage = lazy(() => import('./pages/AdminPage'))

// Loading spinner component
function LoadingFallback() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: 'var(--bg-primary, #f5f5f5)'
    }}>
      <div style={{
        width: '50px',
        height: '50px',
        border: '4px solid #e0e0e0',
        borderTop: '4px solid #2196F3',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }}></div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  )
}

function App() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  return (
    <BrowserRouter basename="/">
      {/* Global broadcast controllers */}
      <UrgentBroadcastController />
      <InfoBannerController />
      
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route 
            path="/login" 
            element={isAuthenticated ? <Navigate to="/panel" /> : <LoginPage />} 
          />
          <Route 
            path="/panel" 
            element={isAuthenticated ? <PanelPage /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/admin" 
            element={isAuthenticated ? <AdminPage /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/" 
            element={<Navigate to={isAuthenticated ? "/panel" : "/login"} />} 
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default App
